<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap> 
								<v-flex xs12 sm6 md6>
                  <v-autocomplete
                  label="Sector Name *"
                  item-text="name_with_sn"
                  item-value="id"
                  v-model="formSchema.sector_id"
                  :items="SectorIdList" 
                  :rules="[v => !!v || 'Sector name is required !']"
                  
                  required>
                </v-autocomplete>								
              </v-flex>

								<v-flex xs12 sm6 md6>
								<v-text-field
                  label="Sub Sector Name *"
                  v-model="formSchema.sub_sector_name" 
									:rules="[v => !!v || 'Sub sector name is required !',lng100]"
	                required>	
                ></v-text-field>
								</v-flex>

								<v-flex xs12 sm6 md6>
								<v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
											</v-flex>
              
              
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="reset">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../../services/common.service"); 

export default {
  props: ["formSchema"], 
  
  data: () => ({
    valid: true,
    isActiveVal: 1, 
		SectorIdList:[],    
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Sub Sector"
        : "Add Sub Sector";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },
  
  created() {    
    commonService.getAllData("sector-for-drodown-data").then(res => {
      res.forEach((item, full,index) => {
         item.name_with_sn = item.short_name ? item.sector_name +' ('+item.short_name+')' : item.sector_name
      })
      this.SectorIdList = res;
    });
  },

  methods: { 
    
    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      var formSchema = this.formSchema;       

      if (formSchema.id > 0) {
        commonService
          .updateFormData(formSchema, "sub-sector")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
      } else {
        commonService
          .insertFormData(formSchema, "sub-sector")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
      }
    },

    close: function(data) {
      if(data.status==1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }                      
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/lending/sector/sub_sector/insertForm.vue